module.exports = __webpack_public_path__ + "static/media/tech.577bc9d5.jpeg";